import ApiService from "../../services/api.service";

const state = {
    campaign : null
}

const getters = {
    campaign : state => state.campaign
}

const mutations = {
    setCampaign(state, campaign) {
        state.campaign = campaign
    }
}

const actions = {
    async getCampaign({commit}, data) {
        return new Promise((resolve, reject) => {
            ApiService.get(`/campaign/${data.lang}/${data.slug}`)
                .then(response => {
                    commit('setCampaign', response.data.campaign)
                    resolve()
                }).catch(error => {
                reject(error)
            }).finally(() => {

            })
        });
    }
}

export default {
    namespaced : true,
    state,
    getters,
    actions,
    mutations
}